import React from "react";

const FullScreenLoader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[99999]">
      <div className="flex flex-col items-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-white"></div>
        <p className="text-white mt-4 text-lg">Loading...</p>
      </div>
    </div>
  );
};

export default FullScreenLoader;
